// Size	Width Per Letter (cm)	Starting price (£)	Font Type Price Multiplier	Price per letter (£)	Thin 	Medium	Bold
// Small	6	73.95	Font dependent	11.2	1	Not possible 	Not possible
// Medium	8	81.95	Font dependent	13.6	1	1.3	Not possible
// Large	12	97.95	Font dependent	18.4	1	1.3	1.6
// XL	15	109.95	Font dependent	22	1	1.3	1.6
// XXL	20	129.95	Font dependent	28	1	1.3	1.6

// Small:
// Medium:
// Large:
// XL:
// XXL:
// XXXL:
// XXXXL:
// XXXXXL:
// XXXXXXL:

export const letterSizes: { [key: string]: number } = {
  MINI: 6,
  SMALL: 8,
  MEDIUM: 12,
  LARGE: 16,
  GIANT: 20,
  XXXL: 24,
  XXXXL: 28,
  XXXXXL: 32,
  XXXXXXL: 36,
};

// const basePrices: { [key: string]: number } = {
//   MINI: 89.95,
//   SMALL: 129.95,
//   MEDIUM: 169.95,
//   LARGE: 209.95,
//   GIANT: 249.95,
//   XXXL: 289.95,
//   XXXXL: 329.95,
//   XXXXXL: 369.95,
//   XXXXXXL: 409.96,
// };

const basePriceRange: [number, number] = [89.95, 249.95];
const letterPriceRange: [number, number] = [15, 23];
const sizeRange = [6, 36];

const getPriceFromRatio = (r: number, range: [number, number]) => {
  const delta = Math.abs(range[1] - range[0]);
  return r * delta + Math.min(...range);
};

const neonMultipliers: { [key: string]: number } = { THIN: 1, MEDIUM: 1.05, BOLD: 1.5 };

// const pricePerLetter: { [key: string]: number } = {
//   MINI: 15,
//   SMALL: 18,
//   MEDIUM: 21,
//   LARGE: 24,
//   GIANT: 27,
//   XXXL: 30,
//   XXXXL: 33,
//   XXXXXL: 36,
//   XXXXXXL: 39,
// };

const extras = {
  outdoor: 75,
  remote: 19.95,
  mounting: 4.95,
  proofing: 29.95,
  color: 10,
  font: 10,
  batteries: 14.95,
};

const supportMultipliers: { [key: string]: number } = {
  SHAPE: 1,
  FULL: 1.15,
  LETTER: 1.15,
};

export const calculatPrice = (
  size: string,
  value: any,
  config: { [key: string]: string | number },
  defaultPrice?: ((size: string) => number) | null,
): number => {
  let extraPrice = 0;
  const add = (val: number, condition: boolean) => condition && (extraPrice += val);

  const letterSize = parseFloat(size?.split('_')?.[1] ?? 0) || letterSizes[size];

  const sizeRangeVal = Math.abs(sizeRange[1] - sizeRange[0]);
  const relativeSize = letterSize - Math.min(...sizeRange);
  let ratio = relativeSize / sizeRangeVal;

  const basePrice = getPriceFromRatio(ratio, basePriceRange);
  const letterPrice = getPriceFromRatio(ratio, letterPriceRange);

  // const letterPrice = pricePerLetter[size] ?? size.split('x')[2] ?? pricePerLetter.MEDIUM;
  const neonMultiplier = neonMultipliers[config.neon];
  const supportMultiplier = supportMultipliers[config.support];

  const leaves = value.map((line: any) => line.children).flat();
  const colors = Array.from(new Set<string>(leaves.map((leaf: any) => leaf.color || '#ff4f4f')));
  const fonts = Array.from(new Set<string>(leaves.map((leaf: any) => leaf.family || config.family)));

  const numberOfColors = colors.length - 1;
  const numberOfFonts = fonts.length - 1;

  add(extras.outdoor, config.use === 'OUTDOOR');
  add(extras.remote, config.remote === 'YES');
  add(extras.mounting, config.mounting === 'YES');
  add(extras.proofing, config.proofing === 'YES');
  add(extras.batteries, config.power === 'BATTERIES');
  add(extras.color * numberOfColors, numberOfColors > 0);
  add(extras.font * numberOfFonts, numberOfFonts > 0);

  const contentLength = value.reduce((sum: number, line: any) => {
    const lineContent = line.children
      .map((leaf: any) => leaf.text)
      .join('')
      .replace(/ /g, '');
    const lineLength = lineContent.length;

    return sum + lineLength;
  }, 0);

  const contentPrice = contentLength * letterPrice;

  return Math.max(
    89.95,
    parseFloat(
      ((defaultPrice?.(size) ?? basePrice + contentPrice) * neonMultiplier * supportMultiplier + extraPrice).toString(),
    ),
  );
};
